<p i18n>hotels-manage works!</p>
